module.exports = __webpack_public_path__ + "static/front3-71e2f23053a51a61bab0de1ffe8668a2.jpg";